import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { FiltersGrid } from '../types';
import { ReferenceBookEntity, ReferenceBookGrid } from './types';

export const referenceBooksApi = createApi({
  reducerPath: 'referenceBooksApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/catalog-types`,
  }),
  tagTypes: ['ReferenceBooksList', 'ReferenceBookEntities'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getReferenceBooksList: builder.query<
      ReferenceBookGrid[],
      FiltersGrid | void
    >({
      query: (params = {}) => {
        return {
          url: `/query`,
          params,
        };
      },
      providesTags: () => ['ReferenceBooksList'],
    }),
    getReferenceBook: builder.query<ReferenceBookEntity[], FiltersGrid | void>({
      query: (params = {}) => {
        return {
          url: `/items`,
          params,
        };
      },
      providesTags: () => ['ReferenceBookEntities'],
    }),
  }),
});

export const { useGetReferenceBooksListQuery, useGetReferenceBookQuery } =
  referenceBooksApi;
